
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/meetings/quick-call/new",
      function () {
        return require("private-next-pages/admin/meetings/quick-call/new.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/meetings/quick-call/new"])
      });
    }
  